import './ReviewPages.scss';

import React, {useEffect, useState} from 'react';
import {Button, Container, InputGroup, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";

import {useDispatch} from "react-redux";

import {AppDispatch} from "../../../services/store/store";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import ReviewStar from "../components/ReviewStar";
import {handleRatingUpdated, handleToggleShareComment} from "../../../services/store/reducers/postRound/slice";
import Avatar from "../../../components/Avatar";
import ErrorText from "../../../components/ErrorText";
import ArrowLeftIcon from "../../../icons/ArrowLeftIcon";
import {IconSize} from "../../../services/IconConstants";
import {useNavigate} from "react-router-dom";
import {buildUrl, REVIEW_CADDIE} from "../../../services/PageUtils";
import Form from "react-bootstrap/Form";
import {ConnectedAccountService} from "../../../services/api/ConnectedAccountService";
import {PaymentService} from "../../../services/api/PaymentService";
import TickIcon from "../../../icons/TickIcon";

interface Props {

}

const PayCaddie = ({}: Props) => {

    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const { errMsg, session } = handicaddieSelector(state => state.postRound)

    const [acceptsPayment, setAcceptsPayment] = useState<boolean | undefined>()
    const [currency, setCurrency] = useState<string>('GBP')
    const [feeTiers, setFeeTiers] = useState<number[][]>([])
    const [amount, setAmount] = useState<string | undefined>()
    const [payInCash, setPayInCash] = useState<boolean>(false)

    const [paymentLoading, setPaymentLoading] = useState<boolean>(false)
    const [paymentErrMsg, setPaymentErrMsg] = useState<string>()

    const {getAccount} = ConnectedAccountService();
    const {createPayment} = PaymentService();

    useEffect(() => {
        if (!session || !session.caddie || !session.caddie.userId) {
            setAcceptsPayment(undefined);
            return;
        }

        checkPaymentAccountStatus(session.caddie.userId)
    }, [session]);

    const checkPaymentAccountStatus = async (userId: string) => {
        let resp = await getAccount(userId)
        if (resp.error || !resp.account) {
            setAcceptsPayment(false)
            return;
        }

        setAcceptsPayment(resp.account.canAcceptPayments && resp.account.canAcceptPayouts);
        setCurrency(resp.account.currency);
        if (resp.account.feeTiers) setFeeTiers(resp.account.feeTiers);
    }

    const submit = async () => {
        setPaymentErrMsg(undefined)
        setPaymentLoading(true)

        try {
            if (!acceptsPayment || payInCash) {
                navigate(buildUrl(REVIEW_CADDIE));
                return;
            }

            if (!amount) {
                setPaymentErrMsg("No amount entered to pay caddie.")
                return;
            }

            let a = Number.parseFloat(amount)
            if (isNaN(a)) {
                setPaymentErrMsg("Amount entered is not correct")
                return;
            }
            let resp = await createPayment(a * 100, userId, caddieId)
            if (resp.error || !resp.checkout || !resp.checkout.url) {
                setPaymentErrMsg("Could not get Stripe URL to complete payment.")
                return;
            }

            window.location.href = resp.checkout.url
        } finally {
            setPaymentLoading(false)
        }
    }

    if (!session) {
        return (<>
            <Container>
                <div className={"findYourCaddie_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div onClick={() => navigate(-1)}>
                    <ArrowLeftIcon
                        size={IconSize.xl}
                        className={"reviewCaddie_goBackArrow"}/>
                </div>

                <Spinner/>
            </Container>
        </>)
    }

    const { review, caddie } = session;

    if (!caddie || acceptsPayment === undefined) {
        return (
            <Container>
                <div className={"findYourCaddie_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div onClick={() => navigate(-1)}>
                    <ArrowLeftIcon
                        size={IconSize.xl}
                        className={"reviewCaddie_goBackArrow"}/>
                </div>

                <div>
                    <span className={"heading"}>Review Your Caddie</span>
                </div>

                <Spinner/>
            </Container>
        )
    }

    const caddieId = caddie.id;
    const userId = caddie.userId;
    const caddieName = caddie.name;

    const getAdminFee = (amountMinor: number): number => {
        for (const tier of feeTiers) {
            if (amountMinor <= tier[0]) return tier[1];
        }
        return feeTiers.length > 0 ? feeTiers[feeTiers.length - 1][1] : 0;
    };

    return (
        <Container>
            <div className={"findYourCaddie_logoContainer"}>
                <HandicaddieLogo size={'lg'} />
            </div>

            {/*<GoBackArrow onPress={navigation.goBack} style={styles.goBackArrow} />*/}

            <div onClick={() => navigate(-1)}>
                <ArrowLeftIcon
                    size={IconSize.xl}
                    className={"reviewCaddie_goBackArrow"} />
            </div>

            <span className={"heading reviewCaddie_container"}>Review Your Caddie</span>

            <div className={"reviewCaddie_caddieInformationContainer"}>
                <div className={"reviewCaddie_caddieContainer"}>
                    <Avatar size={'s'} user={userId}/>
                    <span className={"reviewCaddie_caddieName"}>{caddieName}</span>
                </div>
            </div>

            {/*<div className={"reviewCaddie_line"}/>*/}

            {/*<div className={"reviewCaddie_clickableIconRow reviewCaddie_stars"}>*/}
            {/*    {[...Array(5)].map((_, idx) => {*/}
            {/*        return <ReviewStar*/}
            {/*            key={idx}*/}
            {/*            active={review.rating > 0 && review.rating >= (idx + 1)}*/}
            {/*            onPress={() => dispatch(handleRatingUpdated(idx + 1))}*/}
            {/*        />*/}
            {/*    })}*/}
            {/*</div>*/}

            <div className={"reviewCaddie_line"}/>

            <Form.Label column={'lg'}>Caddie Payment Amount ({currency})</Form.Label>
            {!acceptsPayment && <div className={"payCaddie_notAcceptPayments"}>
                <span>Your caddie hasn't set up cashless payments yet. Please pay in cash.</span>
            </div>}

            <br />
            <Form.Text className={"payCaddie_subText"}>
                <ul>
                    <li>Please include both the caddie base rate and your tip combined in the box below.</li>
                    <li>Your caddie receives 100% of the amount you enter below.</li>
                    <li>A service charge is added to support our platform.</li>
                </ul>
            </Form.Text>

            <div className="payCaddie_searchBarContainer">
                <InputGroup size="lg">
                    <InputGroup.Text>{currency}</InputGroup.Text>
                    <Form.Control
                        type="number"
                        disabled={!acceptsPayment || paymentLoading || payInCash}
                        placeholder="Amount"
                        id="caddiePaymentAmount"
                        className="findYourCaddie_searchInput"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                </InputGroup>

            </div>

            <div className={"reviewCaddie_shareContainer"} onClick={() => setPayInCash(!payInCash)}>
                {payInCash && <TickIcon size={"2em"} className={"reviewCaddie_shareCheckbox"} />}
                {!payInCash && <div className={"reviewCaddie_shareCheckbox reviewCaddie_shareCheckboxUnchecked"} />}

                <span className={"reviewCaddie_shareTxt"}>I’m paying the caddie in cash</span>
            </div>

            <div className={"reviewCaddie_line"} style={{ marginTop: '1em', marginBottom: '1em' }}/>

            {errMsg && <ErrorText>{errMsg}</ErrorText>}
            {paymentErrMsg && <ErrorText>{paymentErrMsg}</ErrorText>}
            <Button className={"reviewCaddie_bottomButton_primary"} onClick={submit} disabled={paymentLoading}>
                {(acceptsPayment && !payInCash) && <span className={"reviewCaddie_btnText"}>PROCEED TO PAYMENT ({currency}{amount ? Number.parseFloat(amount) + getAdminFee(Number.parseFloat(amount) * 100) / 100 : `-`})</span>}
                {(!acceptsPayment || payInCash) && <span className={"reviewCaddie_btnText"}>PROCEED TO REVIEW</span>}
            </Button>
        </Container>
    )
}

export default PayCaddie;